import { render } from "./DocPageSidebar.vue?vue&type=template&id=6d0c2648"
import script from "./DocPageSidebar.vue?vue&type=script&lang=js"
export * from "./DocPageSidebar.vue?vue&type=script&lang=js"

import "./DocPageSidebar.vue?vue&type=style&index=0&id=6d0c2648&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__